import { Box, Card, CardContent, Grid, Skeleton } from "@mui/material";

export interface KpiBudgetCardSkeletonProps {
  cardsCount?: number;
}

const KpiBudgetCardSkeleton = ({
  cardsCount = 4
}: KpiBudgetCardSkeletonProps) => {
  return (
    <Grid container spacing={3} justifyContent="center" className="pb-4">
      <Grid size={{ xs: 12, sm: 12, md: 9 }} sx={{ justifyContent: "center" }}>
        <Grid container spacing={2} justifyContent="center">
          {Array.from({ length: cardsCount }).map((_, index) => (
            <Grid
              size={{ xs: 12, sm: 12, md: 12 / cardsCount }}
              sx={{ justifyContent: "center" }}
              key={`metric-card-skeleton-${index}`}
            >
              <Card className="w-full mt-4">
                <CardContent>
                  <Box className="w-full flex mb-3">
                    <Skeleton
                      variant="rounded"
                      width={80}
                      height={32}
                      sx={{ mr: 2, borderRadius: 1 }}
                    />
                    <Skeleton variant="text" width={60} height={32} />
                  </Box>
                  <Box className="w-full flex mb-2">
                    <Box className="w-2/5">
                      <Skeleton variant="text" width="80%" />
                    </Box>
                    <Box className="w-2/5">
                      <Skeleton variant="text" width="90%" height={32} />
                    </Box>
                    <Box className="w-1/5">
                      <Skeleton variant="text" width="60%" />
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Grid size={{ xs: 12, sm: 12, md: 3 }} sx={{ justifyContent: "center" }}>
        {/* Total Card Skeleton */}
        <Card className="w-full mt-4">
          <CardContent>
            <Box className="w-full flex mb-3">
              <Skeleton
                variant="rounded"
                width={60}
                height={32}
                sx={{ mr: 2, borderRadius: 1 }}
              />
              <Skeleton variant="text" width={60} height={32} />
            </Box>
            <Box className="w-full flex mb-2">
              <Box className="w-2/5">
                <Skeleton variant="text" width="80%" />
              </Box>
              <Box className="w-2/5">
                <Skeleton variant="text" width="90%" height={32} />
              </Box>
              <Box className="w-1/5">
                <Skeleton variant="text" width="60%" />
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default KpiBudgetCardSkeleton;
